export const content = {
  errors: {
    required: 'Eingabe erforderlich',
    zonesApi:
      'Zu Ihrer Auswahl konnte keine Schneezone oder Windzone gefunden werden. Bitte wiederholen Sie Ihre Suche oder schreiben Sie an unsere Anwendungstechnik:',
    altitude:
      'Für diese Konfiguration ist eine individuelle Berechnung erforderlich. Hierzu berät Sie gerne unsere Anwendungstechnik:',
  },
}
